<template>
  <generic-content
      :isLinkable="false"
      :isEditable="isEditable"
      :isPayable="false"
      :isDeletable="isDeletable"
      :isDownloadable="isDownloadable"
      :isViewable="isViewable"
      :is-selected="isSelected"
      @click="isParentMethodPriority?$emit('click'):download()"
      @download="download"
      @toRoute="isParentMethodPriority?$emit('toRoute'):''"
      @view="$emit('view')"
      @edit="$emit('edit')"
      @pay="$emit('pay')"
      @delete="$emit('delete')"
  >
    <template #bodyContent>
      <div class="d-flex justify-content-between h5">
        <div class="text-truncate">
          {{ event.title }}
        </div>
      </div>
      <small class="d-flex justify-content-between">
        <div class="text-truncate">
          <i>{{ event.startDate|moment('LL')|capitalize }}</i>
        </div>
        <div class="text-truncate">
          <i>{{ event.endDate|moment('LL')|capitalize }}</i>
        </div>
<!--        <div>-->
<!--          {{ currency(event.net) }}-->
<!--        </div>-->
      </small>

    </template>

  </generic-content>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { currency } from '@/utils/filter'

import GenericContent from './Content'

export default {
  components: {
    GenericContent
  },
  props: {
    event: {
      type: Object,
      default: () => { }
    },
    isDownloadable: {
      type: Boolean,
      default: false
    },
    isViewable: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isDeletable: {
      type: Boolean,
      default: true
    },
    isParentMethodPriority: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    const download = () => {
      if (props.event.paySlip) {
        // console.log(props.event.receipt.url)
        let link = document.createElement('a')
        link.setAttribute('target', '_blank')
        link.href = props.event.paySlip.url
        link.click()
      }
    }

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      currency,

      // Data

      // Computed

      // Methods
      download,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>